module.exports = ".cssIsValid.ng-valid[required], .cssIsValid.ng-valid.required  {\r\n    border-left: 5px solid #42A948; /* green */\r\n}\r\n.cssIsValid.ng-invalid:not(form)  {\r\n    border-left: 5px solid #a94442; /* red */\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/account/resetAccount/resetAccount.component.css
// module id = ./src/app/account/resetAccount/resetAccount.component.css
// module chunks = main